export default {
  hour: 'Hora',
  minute: 'Minuto',
  adjustTime: '{field}: aumentar ou diminuir',
  invalidDateTime: 'Informe uma data e hora válidas.',
  timePartPlaceholder: '00',
  mask: {
    format: '00/00/0000',
    l18n: 'd/m/Y',
    placeholder: 'dd/mm/aaaa',
    dt_format: '00/00/0000 - 00:00',
    dt_l18n: 'd/m/Y - H:i',
    dt_placeholder: 'dd/mm/aaaa hh:mm',
  },
  completeDayNames: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
  longDayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
  shortDayNames: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  uniqueDayNames: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  monthNames: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],
  holidays: {
    '01-01': 'Confraternização Universal',
    '04-21': 'Tiradentes',
    '05-01': 'Dia do Trabalhador',
    '09-07': 'Independência do Brasil',
    '10-12': 'Nossa Senhora Aparecida',
    '11-02': 'Finados',
    '11-15': 'Proclamação da República',
    '12-25': 'Natal',
  },
  holidayNames: {
    carnival: 'Carnaval',
    corpusChristi: 'Corpus Christi',
    easter: 'Páscoa',
    goodFriday: 'Sexta-feira Santa',
  }
};
